import axios from "@/axios/axios";

const actions = {
  async GET_ALL(context){
    try{
      let {data} = await axios.get('tasks', {
        params: {
          users_id: context.rootGetters['appUser/id']
        }
      });

      let tasks = data.filter(task => ![9].includes(task.category_id));

      context.commit('SET_ALL', tasks);
      return tasks;
    }
    catch(e){
      context.commit('SET_ALL', []);
      return [];
    }
  }
};

export default actions;
